import FeedPage from "./FeedPage";
import { mockFeedData } from "./mockData";

export const FeedPageType = {
	type: "feed",
	defaultTitle: "Feed", // This can be changed by the user to "Home" or anything else
	icon: "newspaper-outline",
	component: FeedPage,

	// Mock data for testing
	mockData: mockFeedData,

	// Feed-specific section types
	sectionTypes: {
		featured: {
			type: "featured",
		},
		events: {
			type: "events",
		},
		activity: {
			type: "activity",
		},
		quickAccess: {
			type: "quickAccess",
		},
		announcements: {
			type: "announcements",
		},
	},

	// Feed-specific layouts
	layouts: {
		hero: {
			name: "Hero",
			description: "Large featured content with image background",
		},
		cards: {
			name: "Cards",
			description: "Content displayed in card format",
		},
	},
};
